<template>
    <el-container class="content" style="display: block;position: relative;background-color: #000000;">
      <div style="width: 100%;background-color: #1a1a1a;z-index: 2;position: relative;" :style="{'width': screenWidth+'px','height':screenHeight*0.05+'px'}">
       
       <div class="xiaoguox-info">
         <span class="xiaoguox-info-text" style="right: 225px;top: 9px;">
           <img src="https://images.yoooooo.com/yzzmshouye/data.png" @click="back()" />
         </span>
         <span class="xiaoguox-info-text" style="right: 105px;">18520599388</span>
         <span class="xiaoguox-info-text" style="right: 45px;top: 11px;">
           <img src="https://images.yoooooo.com/yzzmshouye/filter.png" @click="back()" />
         </span>
         <span class="xiaoguox-info-text" style="right: 5px;top: 10px;">
           <img src="https://images.yoooooo.com/yzzmshouye/exit.png" @click="back()" />
         </span>
         
       </div>
      </div>
      <div style="width: 40%;background-color: #212121;z-index: 2;position: relative;overflow: scroll;" :style="{'width': screenWidth*0.4+'px','height':screenHeight+'px','margin-left':screenWidth*0.3+'px'}">
        <div class="touxiang">
            <img src="https://images.yoooooo.com/UI/AI_baijiqiren/AI_baijiqiren_20_GIF/rabbit_8.gif" />
        </div>
        <div style="width: 100%;color: #fff;font-size: 18px;text-align: center;margin-top: 10px;">宇宙之幂已经陪伴您<span style="color: aquamarine;font-size: 20px;">12</span>天</div>
        <div style="background-color: #333;width: 100%;color: #fff;font-size: 24px;text-align: center;margin-top: 15px;">充值和费用</div>
        <div style="background-color: #333;width: 100%;color: #fff;font-size: 24px;text-align: center;margin-top: 10px;">长期收入汇总</div>
        <div style="margin-top: 15px;">
            <div style="background-color: #333;width: 100%;color: #fff;font-size: 20px;padding-left: 15px;">账号&安全</div>
            <div style="background-color: #333;width: 100%;color: #fff;font-size: 20px;margin-top: 5px;padding-left: 15px;">帮助文档</div>
            <div style="background-color: #333;width: 100%;color: #fff;font-size: 20px;margin-top: 5px;padding-left: 15px;">服务中心</div>
            <div style="background-color: #333;width: 100%;color: #fff;font-size: 20px;margin-top: 5px;padding-left: 15px;">设置</div>
        </div>
      </div>
     
     <div style="width: 100%;background-color: #1a1a1a;z-index: 2;position: relative;" :style="{'width': screenWidth+'px','height':screenHeight*0.15+'px'}">
 
     </div>
 
 
 
 
 
 
      <!-- <div class="beian">
 
 
       <a href="http://beian.miit.gov.cn/state/outPortal/loginPortal.action" rel="noreferrer" target="_blank" style="text-decoration:none;color: #fff;background-color: black;">粤ICP备2024237244号@2024 © 宇宙之幂</a>
 
 
      </div> -->
 
 
 
 
 
 
    
 
    </el-container>
 
 
 
 
 
 
 
 </template>
 
 
 <script>
 
   export default {
     data() {
       return {
         
         screenWidth : window.innerWidth,
         screenHeight : window.innerHeight,
         width:(window.innerWidth*1.1-31*6.5)/30,
         height:(window.innerWidth*1.1-31*6.5)/30,
       
 
 
 
       };
     },
     mounted() {
 
       },
       beforeDestroy() {
 
       },
     created() {
 
      
       
       
 
     },
 
     methods:{
     
     
         msg(msg,type){
             this.$message({
               message: msg,
               type: type
             });
         },
 
 
 
     }
 
 
   }
 </script>
 <style>
 
 .xiaoguox-info{
   height: 50%;
   width: 10%;
   top: 20%;
   right: 10px;
   position: absolute;
   
   
 }
 .xiaoguox-info-text{
   color: #fff;
   font-size: 1.4rem;
   position: absolute;
   top: 5px;
 }
 
 .touxiang {
  width: 100%;           /* 父容器宽度自适应 */
  height: 120px;         /* 固定高度，你可以按需调整 */
  display: flex;
  justify-content: center;  /* 水平居中 */
  align-items: center;      /* 垂直居中（如果需要） */
  background-color: #222;   /* 可选背景 */
  overflow: hidden;         /* 避免溢出 */
  border-radius: 10px;      /* 可选圆角 */
  /* position: absolute; */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin-top: 10%;
}
.touxiang img {
  height: 120px;
  width: 120px;             /* 宽度自适应 */
  object-fit: contain;     /* 不裁剪，完整显示；也可改为 cover 裁剪居中 */
  background-color: #fff;
  border-radius: 120px;
}
 </style>
 <style>
 
 
 
   .beian {
     position: fixed; /* 定位为固定位置，覆盖整个视窗 */
     color: #616161;
     /* top: 0; */
     left: 42%;
     /* right: 0; */
     bottom: 0;
 
     z-index: 1000; /* 确保蒙层在其他内容之上 */
   }
 
   .content{
       background: #939AA0;
       width: 100%;
       height: 100%;
   }
   body {
   overflow-x:hidden;
   overflow-y:hidden;
   }
   .el-scrollbar__wrap{
     background-color: black;
   }
 
 
 
 
 
 
 
 </style>
 


// WEBPACK FOOTER //
// src/components/main/new/xiaoguo_userInfo.vue